export class QuoteRow  {
  constructor(
    public readonly id: string,
    public readonly quoteId: string,
    public readonly amount: number,
    public readonly price: number,
    public readonly vatRateValue: number,
    public readonly vatRateId: string,
    public readonly ledgerCodeId: string,
    public readonly text: string,
    public readonly updatedAt: Date
  ) {
  }

  static fromJson(json: any): QuoteRow {
    return new QuoteRow(
      json['id'],
      json['quote_id'],
      json['amount'],
      json['price'],
      json['vat_rate_value'],
      json['vat_rate_id'],
      json['ledger_code_id'],
      json['text'],
      new Date(json['updated_at'])
    )
  }
}